var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg404(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 890,
    height: 700.472,
    viewBox: "0 0 890 700.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 543,
    height: 324,
    transform: "translate(184 27)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_404",
    "data-name": 404,
    transform: "translate(-55 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_page_not_found_su7k",
    transform: "translate(49 237.528)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 436.951,
    cy: 28.927,
    rx: 436.951,
    ry: 28.927,
    transform: "translate(10.887 426.089)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M483.322,269.124c-71.191,0-122.306,45.674-122.306,152.248,0,120.783,51.114,152.756,122.306,152.756S608.672,539.11,608.672,421.372C608.672,295.514,554.513,269.124,483.322,269.124Zm.468,264.911c-49.309,0-75.069-28.928-75.069-112.585,0-73.815,26.815-112.742,76.124-112.742s76.124,25.569,76.124,112.742c0,81.549-27.87,112.586-77.178,112.586Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M318.386,489.883H288.952V403.206a17.359,17.359,0,0,0-17.359-17.359h-6.9a17.359,17.359,0,0,0-17.359,17.359v86.677H164.313a9.91,9.91,0,0,1-8.762-14.539l87.872-166.315a17.359,17.359,0,0,0-7.936-23.806l-5.187-2.45a17.359,17.359,0,0,0-22.721,7.513L100.407,490.773a23.538,23.538,0,0,0-2.78,11.1h0a23.538,23.538,0,0,0,23.538,23.538H247.337v54.809a20.807,20.807,0,0,0,20.807,20.807h0a20.807,20.807,0,0,0,20.807-20.807V525.407h29.435a17.762,17.762,0,0,0,17.762-17.762h0a17.762,17.762,0,0,0-17.762-17.762Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M863.432,489.883H834V403.206a17.359,17.359,0,0,0-17.357-17.359h-6.9a17.359,17.359,0,0,0-17.359,17.359v86.677H709.359a9.91,9.91,0,0,1-8.762-14.539L788.47,309.029a17.359,17.359,0,0,0-7.935-23.806l-5.187-2.45a17.359,17.359,0,0,0-22.721,7.513L645.454,490.773a23.538,23.538,0,0,0-2.78,11.1h0a23.538,23.538,0,0,0,23.538,23.538H792.384v54.809a20.807,20.807,0,0,0,20.807,20.807h0A20.807,20.807,0,0,0,834,580.216V525.407h29.435A17.762,17.762,0,0,0,881.2,507.645h0a17.762,17.762,0,0,0-17.763-17.762Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M326.506,479.733H297.072V393.056A17.359,17.359,0,0,0,279.713,375.7h-6.9a17.359,17.359,0,0,0-17.359,17.359v86.677H172.432a9.91,9.91,0,0,1-8.762-14.539l87.873-166.315a17.359,17.359,0,0,0-7.936-23.806l-5.187-2.45a17.359,17.359,0,0,0-22.721,7.513L108.527,480.623a23.538,23.538,0,0,0-2.78,11.1h0a23.538,23.538,0,0,0,23.538,23.538H255.457v54.809a20.807,20.807,0,0,0,20.807,20.807h0a20.807,20.807,0,0,0,20.807-20.807V515.258h29.435A17.762,17.762,0,0,0,344.268,497.5h0a17.762,17.762,0,0,0-17.761-17.762Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M878.657,479.733H849.222V393.056A17.359,17.359,0,0,0,831.864,375.7h-6.9a17.359,17.359,0,0,0-17.359,17.359v86.677H724.584a9.91,9.91,0,0,1-8.762-14.539L803.7,298.879a17.359,17.359,0,0,0-7.936-23.806l-5.187-2.45a17.359,17.359,0,0,0-22.721,7.513L660.678,480.623a23.538,23.538,0,0,0-2.78,11.1h0a23.538,23.538,0,0,0,23.538,23.538H807.609v54.809a20.807,20.807,0,0,0,20.807,20.807h0a20.807,20.807,0,0,0,20.807-20.807V515.258h29.435A17.762,17.762,0,0,0,896.42,497.5h0a17.762,17.762,0,0,0-17.763-17.762Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M499.561,259.989c-71.191,0-122.306,45.674-122.306,152.248,0,120.783,51.115,152.756,122.306,152.756s125.351-35.017,125.351-152.756C624.912,286.379,570.753,259.989,499.561,259.989Zm.468,264.911c-49.309,0-75.069-28.928-75.069-112.585,0-73.815,26.815-112.742,76.124-112.742s76.124,25.569,76.124,112.742c0,81.549-27.87,112.586-77.178,112.586Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M529.557,283.354c-.644,2.645-3.419,4.764-6.493,6.244-6.463,3.112-14.434,4.041-22.166,4.352a37.423,37.423,0,0,1-5.918-.109,17.012,17.012,0,0,1-10.148-4.665,1.392,1.392,0,0,1,.036-2.356c4.116-4.522,10.986-7.294,17.906-9.291,5.247-1.514,14.4-5.435,20.121-4.906C528.437,273.137,530.369,280.014,529.557,283.354Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M529.557,283.354c-.644,2.645-3.419,4.764-6.493,6.244-6.463,3.112-14.434,4.041-22.166,4.352a37.423,37.423,0,0,1-5.918-.109,17.012,17.012,0,0,1-10.148-4.665,1.392,1.392,0,0,1,.036-2.356c4.116-4.522,10.986-7.294,17.906-9.291,5.247-1.514,14.4-5.435,20.121-4.906C528.437,273.137,530.369,280.014,529.557,283.354Z",
    transform: "translate(-52.23 -130.783)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M886.261,478.314a17.24,17.24,0,1,0,2.3-33.064l.431,8.873-4.2-7.6a17.175,17.175,0,0,0-8.85,9.71,16.908,16.908,0,0,0-.992,4.663,17.237,17.237,0,0,0,11.312,17.421Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M907.036,581.23c-1.482-7.546,4.94-14.237,11.283-18.585s13.755-8.621,15.919-16c3.11-10.606-6.155-20.319-13.366-28.7a103.8,103.8,0,0,1-13.687-20.342,28,28,0,0,1-3.274-9.25c-.569-4.7.942-9.379,2.463-13.864q7.6-22.408,16.259-44.441",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M886.965,476.029a17.24,17.24,0,1,0,2.3-33.064l.431,8.873-4.2-7.6a17.175,17.175,0,0,0-8.85,9.71,16.9,16.9,0,0,0-.992,4.663A17.237,17.237,0,0,0,886.965,476.029Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M904.924,426.989a17.22,17.22,0,0,1,12.408-10.932l1.419,8.436,2.632-8.86a17.238,17.238,0,1,1-16.46,11.356Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M905.868,423.942a17.22,17.22,0,0,1,12.409-10.932l1.419,8.436,2.632-8.86a17.238,17.238,0,1,1-16.46,11.356Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M917.837,518.12a17.238,17.238,0,0,0,15.257-30.668l-2.022,6.808-1.434-8.535a.3.3,0,0,0-.044-.017,17.239,17.239,0,0,0-11.757,32.411Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M918.666,515.034a17.238,17.238,0,0,0,15.257-30.668l-2.022,6.808-1.434-8.535a.307.307,0,0,0-.044-.017,17.239,17.239,0,1,0-11.757,32.411Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M899.9,546.749a17.231,17.231,0,1,0,3.322-13.5L910.9,544.81l-10.5-6.136A17.078,17.078,0,0,0,899.9,546.749Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M900.6,544.465a17.231,17.231,0,1,0,3.322-13.5l7.681,11.561-10.5-6.136A17.079,17.079,0,0,0,900.6,544.465Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M59.692,520.31A11.327,11.327,0,1,0,61.2,498.586l.284,5.83-2.758-5a11.284,11.284,0,0,0-5.814,6.38,11.106,11.106,0,0,0-.652,3.064,11.325,11.325,0,0,0,7.432,11.446Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M73.34,587.927c-.974-4.958,3.245-9.354,7.413-12.211s9.037-5.664,10.459-10.513c2.044-6.968-4.044-13.35-8.782-18.853a68.19,68.19,0,0,1-8.993-13.364,18.4,18.4,0,0,1-2.151-6.077c-.374-3.089.619-6.162,1.619-9.109q5-14.723,10.682-29.2",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M60.158,518.809a11.327,11.327,0,1,0,1.508-21.723l.284,5.83-2.758-5a11.284,11.284,0,0,0-5.814,6.38,11.107,11.107,0,0,0-.652,3.064,11.325,11.325,0,0,0,7.432,11.445Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M71.955,486.588a11.314,11.314,0,0,1,8.153-7.183l.933,5.542,1.729-5.821a11.326,11.326,0,1,1-10.814,7.461Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M72.577,484.587A11.314,11.314,0,0,1,80.73,477.4l.933,5.542,1.729-5.821a11.326,11.326,0,1,1-10.814,7.461Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M80.442,546.463a11.326,11.326,0,0,0,10.024-20.149l-1.329,4.473-.942-5.608-.029-.011a11.326,11.326,0,1,0-7.725,21.294Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M80.981,544.436A11.326,11.326,0,0,0,91,524.287l-1.329,4.473-.942-5.608-.029-.011a11.326,11.326,0,1,0-7.725,21.294Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M68.65,565.273a11.321,11.321,0,1,0,2.183-8.87l5.047,7.6-6.9-4.032a11.22,11.22,0,0,0-.334,5.306Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#888"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M69.116,563.772A11.321,11.321,0,1,0,71.3,554.9l5.047,7.6-6.9-4.031A11.22,11.22,0,0,0,69.116,563.772Z",
    transform: "translate(-52.23 -130.783)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 14.082,
    cy: 18.224,
    rx: 14.082,
    ry: 18.224,
    transform: "translate(384.307 246.114)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 14.082,
    cy: 18.224,
    rx: 14.082,
    ry: 18.224,
    transform: "translate(460.928 246.528)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M516.472,449.376c0,8.234-11.5,14.91-25.679,14.91s-25.679-6.676-25.679-14.91c0-7.132,8.623-13.1,20.145-14.554a41.507,41.507,0,0,1,5.533-.356,42,42,0,0,1,9.219.994C509.638,437.605,516.472,443.031,516.472,449.376Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 14.082,
    cy: 18.224,
    rx: 14.082,
    ry: 18.224,
    transform: "translate(387.62 241.972)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 14.082,
    cy: 18.224,
    rx: 14.082,
    ry: 18.224,
    transform: "translate(464.242 242.386)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 25.679,
    cy: 14.91,
    rx: 25.679,
    ry: 14.91,
    transform: "translate(416.198 299.542)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 0.828
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M500.319,436.7a4.089,4.089,0,0,1-1.093,2.81,3.594,3.594,0,0,1-2.634,1.166h-8.283a3.864,3.864,0,0,1-3.728-3.976,4.063,4.063,0,0,1,.679-2.271,38.96,38.96,0,0,1,5.533-.38,39.485,39.485,0,0,1,9.219,1.06A4.2,4.2,0,0,1,500.319,436.7Z",
    transform: "translate(-52.23 -130.783)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(397.56 251.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(474.596 251.084)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(478.738 290.016)",
    fill: "#c7c7c7",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 4.142,
    cy: 4.142,
    r: 4.142,
    transform: "translate(377.68 290.016)",
    fill: "#c7c7c7",
    opacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(57 -6)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_online_wishes_dlmr",
    transform: "translate(247.477 27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M352.193,133.824c-17.5-68.8-77.957-118.471-148.923-120.463-37.517-1.053-77,11.39-105.74,54.932-51.383,77.837,3.158,131.624,41.182,157.183a237.923,237.923,0,0,1,49.178,44.2c25.684,30.478,75.094,68.351,133.939,9.01C364.478,235.677,363.847,179.655,352.193,133.824Z",
    transform: "translate(-25.711 -13.301)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 6.817,
    cy: 8.181,
    rx: 6.817,
    ry: 8.181,
    transform: "translate(390.336 114.029)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 6.817,
    cy: 8.181,
    rx: 6.817,
    ry: 8.181,
    transform: "translate(12.076 108.965)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M418.384,286.269c0,18.395-86.508,51.032-193.22,51.032S42.072,271.162,42.072,252.767s76.379,17.92,183.092,17.92S418.384,267.874,418.384,286.269Z",
    transform: "translate(-25.711 -13.301)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M418.384,286.269c0,18.395-86.508,51.032-193.22,51.032S42.072,271.162,42.072,252.767s76.379,17.92,183.092,17.92S418.384,267.874,418.384,286.269Z",
    transform: "translate(-25.711 -13.301)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M418.384,286.074c0,18.395-86.508,33.307-193.22,33.307S42.072,271.162,42.072,252.767s76.379,0,183.092,0S418.384,267.679,418.384,286.074Z",
    transform: "translate(-25.711 -13.301)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M195.632,234.236l-3.913,24.983S172.455,269.453,186,269.754s77.356,0,77.356,0,12.341,0-7.224-10.836l-3.913-26.187Z",
    transform: "translate(-25.711 -13.301)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M183.275,269.483a53.28,53.28,0,0,1,8.444-5.589l3.913-24.983,56.587.053,3.913,24.629a51.379,51.379,0,0,1,9.042,5.95c2.513-.573,5.259-2.7-9.042-10.625l-3.913-26.187-56.587,1.5-3.913,24.983S175.531,267.82,183.275,269.483Z",
    transform: "translate(-25.711 -13.301)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 254.945,
    height: 177.589,
    rx: 8.964,
    transform: "translate(70.441 46.808)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 237.788,
    height: 133.041,
    transform: "translate(79.02 56.29)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 1.505,
    cy: 1.505,
    r: 1.505,
    transform: "translate(196.409 50.571)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M351.1,213.166v15.567a8.963,8.963,0,0,1-8.965,8.964H105.116a8.963,8.963,0,0,1-8.964-8.965V213.166Z",
    transform: "translate(-25.711 -13.301)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M264.434,272.707v3.01H102.5v-2.408l.223-.6,3.991-10.836H261.123Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M352.464,283.061c-.295,1.261-1.409,2.592-3.925,3.85-9.03,4.515-27.391-1.2-27.391-1.2S307,283.3,307,276.978a11.288,11.288,0,0,1,1.24-.737c3.8-2.009,16.384-6.965,38.7.21a9.308,9.308,0,0,1,4.243,2.78A4.44,4.44,0,0,1,352.464,283.061Z",
    transform: "translate(-25.711 -13.301)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M352.464,283.061c-11.053,4.235-20.9,4.551-31.015-2.471a22.2,22.2,0,0,0-13.208-4.349c3.8-2.009,16.384-6.965,38.7.21a9.308,9.308,0,0,1,4.243,2.78A4.44,4.44,0,0,1,352.464,283.061Z",
    transform: "translate(-25.711 -13.301)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 3.913,
    cy: 1.204,
    rx: 3.913,
    ry: 1.204,
    transform: "translate(308.982 264.881)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 5.719,
    cy: 5.719,
    r: 5.719,
    transform: "translate(192.195 206.488)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M264.434,272.707v3.01H102.5v-2.408l.223-.6Z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 6.817,
    cy: 8.181,
    rx: 6.817,
    ry: 8.181,
    transform: "translate(344.758 49.362)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M236.349,103.455v11.776l-9.518,15.163V118.779Z",
    opacity: 0.15
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.565df5c33c797a79e7387a7169d17973.svg";
export { ForwardRef as ReactComponent };